(function () {
  var requestId = 0;

  function esc(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function carsLabel(n) {
    var mod10 = n % 10;
    var mod100 = n % 100;
    var word = 'vozů';
    if (n === 1) word = 'vůz';
    else if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) word = 'vozy';
    return n + ' ' + word;
  }

  function mergeModels(rows) {
    var order = [];
    var map = {};
    rows.forEach(function (row) {
      if (!row || !row.models) return;
      row.models.forEach(function (model) {
        if (!model || !model.id) return;
        if (!map[model.id]) {
          map[model.id] = Object.assign({}, model);
          order.push(model.id);
        } else {
          var current = map[model.id];
          current.count = (current.count || 0) + (model.count || 0);
          if (model.price != null && (current.price == null || model.price < current.price)) {
            current.price = model.price;
            current.price_text = model.price_text;
            if (model.image) current.image = model.image;
          }
          if (model.awd) current.awd = true;
          if (model.range && (!current.range || model.range > current.range)) current.range = model.range;
          if (model.battery && (!current.battery || model.battery > current.battery)) current.battery = model.battery;
          if (model.fuels && current.fuels !== model.fuels) {
            current.fuels = [current.fuels, model.fuels]
              .filter(Boolean)
              .join(', ')
              .split(',')
              .map(function (part) {
                return part.trim();
              })
              .filter(function (part, index, list) {
                return part && list.indexOf(part) === index;
              })
              .join(', ');
          }
        }
      });
    });
    return order.map(function (id) {
      return map[id];
    });
  }

  function modelHref(gid, paramName) {
    var url = new URL(window.location.href);
    ['page', 'section_id', 'view'].forEach(function (key) {
      url.searchParams.delete(key);
    });
    url.searchParams.set(paramName || 'filter.p.m.custom.car_model', gid);
    return url.pathname + '?' + url.searchParams.toString();
  }

  function makeOnlyHref(makeParam, makeGid) {
    var url = new URL(window.location.href);
    url.searchParams.forEach(function (_, key) {
      if (key.indexOf('car_model') !== -1 || key === 'page' || key === 'section_id' || key === 'view') {
        url.searchParams.delete(key);
      }
    });
    if (makeParam && makeGid) url.searchParams.set(makeParam, makeGid);
    return url.pathname + '?' + url.searchParams.toString();
  }

  function cardHtml(model, note, paramName, buttonLabel) {
    var title = model.title || [model.make, model.name].filter(Boolean).join(' ');
    var href = modelHref(model.gid, paramName);
    var image = model.image
      ? '<img src="' + esc(model.image) + '" alt="' + esc(title) + '" width="500" height="375" loading="lazy">'
      : '';
    var price = model.price_text || '';
    return (
      '<li class="related-models__card">' +
      image +
      '<h3>' +
      esc(title) +
      '</h3>' +
      (price ? '<p class="related-models__price">od ' + esc(price) + ' Kč <span>' + esc(note) + '</span></p>' : '') +
      '<span class="related-models__btn">' +
      esc(buttonLabel) +
      '</span>' +
      '<a href="' +
      esc(href) +
      '" aria-label="' +
      esc(title) +
      '">&nbsp;</a></li>'
    );
  }

  function setRelatedVisible(root, visible) {
    if (!root) return;
    root.hidden = !visible;
  }

  function refreshRelatedModels() {
    var root = document.querySelector('[data-related-models]');
    if (!root) return;

    var grid = root.querySelector('[data-related-models-grid]');
    if (!grid) return;

    var total = Number(root.getAttribute('data-models-total') || 0);
    if (total < 1) {
      grid.innerHTML = '';
      setRelatedVisible(root, false);
      return;
    }

    var excludeGid = root.getAttribute('data-exclude-model-gid') || '';
    var excludeName = (root.getAttribute('data-exclude-model-name') || '').toLowerCase();
    var makeParam = root.getAttribute('data-make-param') || 'filter.p.m.custom.car_make';
    var makeGid = root.getAttribute('data-make-gid') || '';
    var modelParam = root.getAttribute('data-model-param') || 'filter.p.m.custom.car_model';
    var note = root.getAttribute('data-price-note') || '';
    var buttonLabel = root.getAttribute('data-card-button') || 'Zobrazit nabídky';
    var ctaTemplate = root.getAttribute('data-cta-text') || '';

    var id = (requestId += 1);
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    params.delete(modelParam);
    params.set('view', 'brand-models');

    var pages = Math.max(1, Math.ceil(total / 50));
    var jobs = [];
    for (var page = 1; page <= pages; page += 1) {
      params.set('page', String(page));
      jobs.push(
        fetch(window.location.pathname + '?' + params.toString(), { credentials: 'same-origin' })
          .then(function (r) {
            return r.json();
          })
          .catch(function () {
            return null;
          }),
      );
    }

    Promise.all(jobs)
      .then(function (rows) {
        if (id !== requestId || !root.isConnected) return;
        var models = mergeModels(rows).filter(function (model) {
          if (excludeGid && model.gid === excludeGid) return false;
          if (excludeName && String(model.name || '').toLowerCase() === excludeName) return false;
          return true;
        });
        models.sort(function (a, b) {
          return (b.count || 0) - (a.count || 0);
        });

        var picked = models.slice(0, 2);
        if (picked.length < 1) {
          grid.innerHTML = '';
          setRelatedVisible(root, false);
          return;
        }

        var totalCars = models.reduce(function (sum, m) {
          return sum + (m.count || 0);
        }, 0);

        setRelatedVisible(root, true);

        var html = picked
          .map(function (model) {
            return cardHtml(model, note, modelParam, buttonLabel);
          })
          .join('');

        var ctaHref = makeOnlyHref(makeParam, makeGid);
        var ctaText = ctaTemplate
          .replace('{count}', carsLabel(totalCars))
          .replace('{make}', root.getAttribute('data-make-name') || '');
        var ctaButton = (root.getAttribute('data-cta-button') || 'Zobrazit vše').replace(
          '{make}',
          root.getAttribute('data-make-name') || '',
        );
        var ctaHeading = ctaText;
        var ctaLead = '';
        var splitAt = ctaText.indexOf('. ');
        if (splitAt > 0) {
          ctaHeading = ctaText.slice(0, splitAt + 1);
          ctaLead = ctaText.slice(splitAt + 2);
        }
        html +=
          '<li class="related-models__card related-models__card--cta">' +
          '<div class="related-models__cta-body">' +
          '<span class="related-models__cta-icon">' +
          '<svg aria-hidden="true" fill="none" viewBox="0 0 24 24"><rect height="18" rx="2" width="16" x="4" y="3"></rect><path d="M8 8h8M8 12h8M8 16h5"></path></svg>' +
          '</span>' +
          '<h3>' +
          esc(ctaHeading) +
          '</h3>' +
          (ctaLead ? '<p>' + esc(ctaLead) + '</p>' : '') +
          '</div>' +
          '<a class="related-models__advice" href="' +
          esc(ctaHref) +
          '">' +
          esc(ctaButton) +
          '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
          '</a>' +
          '<a href="' +
          esc(ctaHref) +
          '" tabindex="-1" aria-hidden="true">&nbsp;</a></li>';

        grid.innerHTML = html;
        grid.setAttribute('aria-busy', 'false');

        var linksWrap = root.querySelector('.related-models__links');
        if (linksWrap && !linksWrap.querySelector('a') && models.length > 0) {
          var makeName = root.getAttribute('data-make-name') || '';
          var makeGenitive = root.getAttribute('data-make-genitive') || makeName;
          var chips = models.slice(0, 3).map(function (model) {
            var title = [makeName, model.name].filter(Boolean).join(' ');
            var href = modelHref(model.gid, modelParam);
            return '<a class="related-models__chip" href="' + esc(href) + '">' + esc(title) + '</a>';
          });
          chips.unshift(
            '<a class="related-models__chip related-models__chip--brand" href="' +
              esc(ctaHref) +
              '">' +
              esc('Všechny vozy ' + makeGenitive) +
              '</a>',
          );
          linksWrap.innerHTML = chips.join('');
        }

        var countEl = root.querySelector('[data-related-models-count]');
        if (countEl) countEl.textContent = carsLabel(totalCars);

        document.dispatchEvent(
          new CustomEvent('related-models:ready', {
            detail: { models: models },
          }),
        );
      })
      .catch(function () {
        if (id !== requestId || !root.isConnected) return;
        setRelatedVisible(root, false);
      });
  }

  window.refreshRelatedModels = refreshRelatedModels;
  document.addEventListener('DOMContentLoaded', refreshRelatedModels);
})();
